import React, { useEffect, useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../utils/authContext';
import { CONFIG } from '../../utils/config';
import { User } from '../../utils/types';


const Logout: React.FC = () => {
  const [isValidPath, setIsValidPath] = useState(true);
    const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const {logout } = useAuth();
  const [userdata, setUserData] = useState<User | null>(null);
useEffect(() => {
    logout();

    // Redirect to the login page
    navigate(CONFIG.urls.getLoginUrl());
  }, [logout,dispatch, navigate]);
  

  return null;
};

export default Logout;

